import { fetcher, sendData } from "@/services/api/fetcher";
import { ApiResponse, DataObject } from "@/types";
import { useQuery } from "@tanstack/react-query";
import { ProfileResponse } from "./interface";
import { useFormMutation } from "@/hooks/useFormMutation";
import { UpdateProfilePayload } from "./validation";
import useGetToken from "@/hooks/useGetToken";
import { unsubscribeWebPush } from "../webpush/api";
import Cookies from "js-cookie";

const getProfile = async (): Promise<
  ApiResponse<DataObject<ProfileResponse>>
> => {
  const response = await fetcher(`user/profile`);
  if (response.status === 401 || response.status === 403) {
    await unsubscribeWebPush();
    localStorage.clear();
    document.cookie.split(";").forEach((cookie) => {
      const cookieName = cookie.split("=")[0].trim();
      Cookies.remove(cookieName);
    });
    Cookies.remove("accessToken");
    window.location.href = "/login";
  }
  return response;
};

export const useGetProfile = () => {
  const { decode } = useGetToken();
  return useQuery<ApiResponse<DataObject<ProfileResponse>>, Error>({
    queryKey: ["useGetProfile"],
    queryFn: () => getProfile(),
    enabled: !!decode,
  });
};

export const useUpdateProfile = () => {
  return useFormMutation<
    ApiResponse<DataObject<ProfileResponse>>,
    Error,
    UpdateProfilePayload
  >({
    mutationFn: async (
      data
    ): Promise<ApiResponse<DataObject<ProfileResponse>>> => {
      const endpoint = `user/profile`;
      const delay = new Promise((resolve) => setTimeout(resolve, 2000));
      const response: ApiResponse<DataObject<ProfileResponse>> = await sendData(
        endpoint,
        data,
        "PUT"
      );
      await delay;
      return response;
    },
    loadingMessage: "Mengubah data...",
    successMessage: "Data berhasil diubah",
  });
};
